<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        size="small"
        label-width="120px"
      >
        <el-form-item label="订单号">
          <el-input v-model="form.orderNo" maxlength="20" disabled></el-input>
        </el-form-item>
        <el-form-item label="寄件人姓名" prop="senderName">
          <el-input v-model="form.senderName"></el-input>
        </el-form-item>
        <el-form-item label="寄件人电话" prop="senderTel">
          <el-input v-model="form.senderTel" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="寄件人地址" prop="senderAddress">
          <el-input v-model="form.senderAddress"></el-input>
        </el-form-item>
        <el-form-item label="收件人姓名">
          <el-input v-model="form.receiverName" disabled></el-input>
        </el-form-item>
        <el-form-item label="收件人电话">
          <el-input
            v-model="form.receiverTel"
            maxlength="11"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="收件人地址">
          <el-input v-model="form.receiverAddress" disabled></el-input>
        </el-form-item>
        <el-form-item label="邮费" prop="postage">
          <el-input v-model="form.postage" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="快递公司" prop="expressCompany">
          <el-select v-model="form.expressCompany" placeholder="请选择快递公司">
            <el-option
              v-for="(item, index) in wlExpressList"
              :key="index"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="expressNo">
          <el-input v-model="form.expressNo" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="快递状态" prop="expressState">
          <el-radio-group v-model="form.expressState">
            <el-radio style="margin: 5px 20px" :label="1">待发货</el-radio>
            <el-radio style="margin: 5px 20px" :label="2">已发货</el-radio>
            <el-radio style="margin: 5px 20px" :label="3">运输中</el-radio>
            <el-radio style="margin: 5px 20px" :label="4">已签收</el-radio>
            <el-radio style="margin: 5px 20px" :label="5">已拒收</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" type="primary" @click="handleOk"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
// import { listMixin } from '@/mixins/listMixin';

export default {
  components: {},
  // mixins: [listMixin],
  props: {},
  data() {
    return {
      disableMixinCreated: true,
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: {
        id: "",
        receiverName: "",
        receiverTel: "",
        receiverAddress: "",
        orderNo: "",
      },
      validatorRules: {
        senderName: [
          {
            // required: true,
            message: "请输入寄件人名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        senderTel: [
          {
            // required: true,
            message: "请输入电话号码",
            trigger: "blur",
          },
          {
            len: 11,
            message: "电话号码长度应为11个字符",
            trigger: "blur",
          },
        ],
        senderAddress: [
          {
            // required: true,
            message: "请输入寄件人地址",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
        postage: [
          {
            // required: true,
            message: "请输入寄件人地址",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        expressCompany: [
          { required: true, message: "请选择快递公司", trigger: "change" },
        ],
        expressNo: [
          {
            required: true,
            message: "请输入快递单号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        expressState: [
          { required: true, message: "请选择快递状态", trigger: "change" },
        ],
      },
      url: {
        queryOrderInfo: "/mallOrder/queryMallExpress/",
        edit: "/mallOrder/editMallExpress",
        getExpress: "/wlExpress/queryList",
      },
      wlExpressList: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    add() {
      this.edit({});
    },
    async edit(record) {
      let result = await httpAction(this.url.getExpress, {}, "post");
      if (result.code !== 200) return this.$message.error(result.msg);
      this.wlExpressList = result.data;
      this.visible = true;
      let res = await httpAction(
        this.url.queryOrderInfo + record.expressId,
        {},
        "get"
      );
      if (res.code == 200) {
        this.form = res.data
        this.form.id = res.data.id;
        // this.form.id = res.data.id;
        this.form.receiverName = res.data.receiverName;
        this.form.receiverTel = res.data.receiverTel;
        this.form.receiverAddress = res.data.receiverAddress;
        this.form.orderNo = res.data.orderNo;
        this.form.expressCompany = result.data[0].code
      } else {
        this.$message.warning(res.msg);
      }
    },
    close() {
      this.visible = false;
      this.form.id = "";
      this.form.receiverName = "";
      this.form.receiverTel = "";
      this.form.receiverAddress = "";
      this.form.orderNo = "";
      this.$refs.form.resetFields();
    },
    handleOk() {
      // 触发表单验证
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log(this.form);
          let res = await httpAction(this.url.edit, this.form, "post");
          console.log(res);
          if (res.code == 200) {
            this.$message.success("操作成功");
            this.close();
            this.$emit("editOk");
          } else {
            this.$message.warning(res.msg);
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  .menuBar {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    /*height: calc(100% - 100px);*/
    height: 300px;
    overflow-y: auto;
  }
}
</style>
